module.exports = __webpack_public_path__ + "img/btn_meeting_pressed.79b5b007.png";